import React from 'react';
import { Link } from 'react-router-dom';
import { Lock } from 'lucide-react';

const footerLinkClass = 'text-sm font-medium text-slate-600 hover:text-slate-900';

export default function PublicSiteFooter() {
  return (
    <footer className="border-t border-slate-200 bg-white">
      <div className="mx-auto max-w-[1200px] px-6 pt-8 pb-10">
        <div className="mb-6 flex items-center justify-center gap-2 text-sm text-slate-600">
          <Lock className="h-4 w-4 shrink-0 text-green-600" />
          <span>Secure payments powered by Flutterwave</span>
        </div>

        <div className="grid gap-8 border-t border-slate-100 pt-6 md:grid-cols-12 md:items-center">
          <div className="flex items-center gap-3 md:col-span-4">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-white shadow-sm ring-1 ring-slate-200">
              <img src="/logo.png" alt="DocMania logo" className="h-8 w-8 object-contain" />
            </div>
            <span className="text-xl font-extrabold tracking-tight text-slate-900">
              <span className="text-blue-600">Doc</span>
              <span className="text-orange-500">Mania</span>
            </span>
          </div>

          <nav
            className="flex flex-wrap items-center gap-x-7 gap-y-3 md:col-span-5 md:justify-center"
            aria-label="Footer"
          >
            <Link to="/templates" data-testid="footer-templates-toolkits-link" className={footerLinkClass}>
              Templates &amp; Toolkits
            </Link>
            <Link to="/login" data-testid="footer-login-link" className={footerLinkClass}>
              Login
            </Link>
            <Link to="/privacy" data-testid="footer-privacy-link" className={footerLinkClass}>
              Privacy
            </Link>
            <Link to="/terms" data-testid="footer-terms-link" className={footerLinkClass}>
              Terms
            </Link>
            <Link to="/pricing" data-testid="footer-pricing-link" className={footerLinkClass}>
              Pricing
            </Link>
            <Link to="/refund-policy" data-testid="footer-refund-policy-link" className={footerLinkClass}>
              Refund Policy
            </Link>
            <Link to="/contact" data-testid="footer-contact-link" className={footerLinkClass}>
              Contact
            </Link>
          </nav>

          <div className="text-sm text-slate-500 md:col-span-3 md:text-right">
            © {new Date().getFullYear()} DocMania. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
}
